const getalldevBankreceipt = {data: [], loading: true};

export const GetAllDecBankReceiptReducer = (state = getalldevBankreceipt, action) =>{
    switch(action.type){
        case 'getalldevBankreceipt':
            return{
                data:action.payload,
                loading:action.loader
            }
        default:
            return state;
    }
}